import React from 'react';
import { Chip } from 'components/mui';
import { CaseFilter } from 'containers/pages/cases/types';
import { CustomerOption } from 'api/cases/searchCustomers';
import { ConsultantOption } from 'api/cases/searchConsultants';
import { StatusOption } from 'api/cases/searchStatuses';

interface CaseFilterChipsProps {
  selectedCustomer: CustomerOption | null;
  selectedConsultant: ConsultantOption | null;
  selectedStatuses: StatusOption[];
  dateValue: string;
  onClear: (field: keyof CaseFilter) => void;
}

function CaseFilterChips({
  selectedCustomer,
  selectedConsultant,
  selectedStatuses,
  dateValue,
  onClear,
}: CaseFilterChipsProps) {
  const chipSx = {
    height: 24,
    fontSize: '0.75rem',
    fontWeight: 500,
    '& .MuiChip-deleteIcon': { fontSize: 14 },
  };

  return (
    <>
      {selectedCustomer && (
        <Chip
          label={`Customer: ${selectedCustomer.Name}`}
          size="small"
          onDelete={() => onClear('CustomerId')}
          color="default"
          variant="outlined"
          sx={chipSx}
        />
      )}
      {selectedStatuses.map((s) => (
        <Chip
          key={s.Id}
          label={`Status: ${s.Title}`}
          size="small"
          onDelete={() => onClear('Status')}
          color="default"
          variant="outlined"
          sx={chipSx}
        />
      ))}
      {selectedConsultant && (
        <Chip
          label={`Consultant: ${selectedConsultant.FullName}`}
          size="small"
          onDelete={() => onClear('ConsultantId')}
          color="default"
          variant="outlined"
          sx={chipSx}
        />
      )}
      {dateValue && (
        <Chip
          label={`Date: ${dateValue}`}
          size="small"
          onDelete={() => onClear('Date')}
          color="default"
          variant="outlined"
          sx={chipSx}
        />
      )}
    </>
  );
}

export default CaseFilterChips;
